import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { SortableHandle } from 'react-sortable-hoc';
import { CSSProperties } from '@material-ui/styles';
import { NonHoverBorder } from 'src/theme/colors';
import { ReorderIcon } from 'src/components/Icons';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: NonHoverBorder,
      cursor: 'grab',
    },
  }),
);
interface SortDragButtonProps {
  style?: CSSProperties;
}
export const SortDragButton = SortableHandle((props: SortDragButtonProps) => {
  const classes = useStyles();
  return <ReorderIcon className={classes.root} {...props} />;
});
